// ✉️ 사내 메일 도메인 오타 감지 (2026-09-04) — "powelogics.kr" 같이 편집거리 1~2 의 도메인이면 정타 후보를 돌려준다.
//   정확히 일치하면(=정상) null. 전혀 다른 도메인(gmail 등 직접가입 계정)은 거리가 커서 걸리지 않는다.
//   목록의 정본은 사이드카 /api/tpt/auth/mail-domains (관리자 > 조직 연동 > 이메일 도메인 관리) — 조회 실패 시 아래 기본값.
export const DEFAULT_COMPANY_MAIL_DOMAINS = ['powerlogics.kr', 'topengnet.com'];

/** 서버 목록 조회(공개 GET). 실패·빈 목록이면 기본값. */
export async function loadCompanyMailDomains(): Promise<string[]> {
	try {
		const r = await fetch('/api/tpt/auth/mail-domains');
		if (!r.ok) return DEFAULT_COMPANY_MAIL_DOMAINS;
		const j = await r.json() as { domains?: unknown };
		const list = Array.isArray(j.domains) ? j.domains.filter((d): d is string => typeof d === 'string' && !!d).map((d) => d.toLowerCase()) : [];
		return list.length ? list : DEFAULT_COMPANY_MAIL_DOMAINS;
	} catch { return DEFAULT_COMPANY_MAIL_DOMAINS; }
}

function editDistance(a: string, b: string): number {
	const prev = Array.from({ length: b.length + 1 }, (_, i) => i);
	for (let i = 1; i <= a.length; i++) {
		let diag = prev[0];
		prev[0] = i;
		for (let j = 1; j <= b.length; j++) {
			const tmp = prev[j];
			prev[j] = Math.min(prev[j] + 1, prev[j - 1] + 1, diag + (a[i - 1] === b[j - 1] ? 0 : 1));
			diag = tmp;
		}
	}
	return prev[b.length];
}

export function suggestCompanyDomain(email: string, domains: readonly string[] = DEFAULT_COMPANY_MAIL_DOMAINS): { local: string; typed: string; suggest: string } | null {
	const at = email.lastIndexOf('@');
	if (at <= 0) return null;
	const local = email.slice(0, at);
	const typed = email.slice(at + 1).toLowerCase();
	if (!typed || domains.includes(typed)) return null;
	let best: { suggest: string; d: number } | null = null;
	for (const dom of domains) {
		// 회사명 라벨이 같으면 TLD 만 다른 것(powerlogics.com / .co.kr) — 거리 3 이상이어도 후보 자격.
		//   순위는 항상 실제 편집거리 — 같은 회사가 .kr/.vn 둘 다 있을 때 오타(.vm)가 가까운 쪽(.vn)으로 가야 한다.
		const sameLabel = typed.split('.')[0] === dom.split('.')[0];
		const d = editDistance(typed, dom);
		if ((d <= 2 || sameLabel) && (!best || d < best.d)) best = { suggest: dom, d };
	}
	return best ? { local, typed, suggest: best.suggest } : null;
}
